<div class="row justify-content-center g-0">
  <div class="col-xs-12 col-sm-10 col-md-6">

    @if(!processing()){
      @if(alert){
        <ngb-alert [type]="alert.type">{{ alert.message }}</ngb-alert>
      }      
      @let tmplCurrentGameRound = currentGameRound();
      @if(pool && tmplCurrentGameRound){
        @let tmplViewPeriod = tmplCurrentGameRound.viewPeriod;        
        <div>
          <div class="d-flex flex-nowrap justify-content-between mt-2 mx-1">
            <h1>competitie</h1>
            
            @if(isNowAfterTransferPeriod(pool.getCompetitionConfig())){  
              <app-period-selector
                [competitionConfig]="pool.getCompetitionConfig()"
                [activePeriod]="tmplCurrentGameRound.viewPeriod"
                (selectPeriod)="selectPeriod(pool, $event)"
              ></app-period-selector>
            }
            
            <div>
              @if(poolPouleId){
                <button (click)="navigateToChat(pool,poolPouleId)" type="button"
                  class="btn btn-outline-dark me-1 position-relative">
                  <fa-icon [icon]=faMessage></fa-icon>
                  <span class="ms-1 d-none d-sm-inline"> chat</span>
                  @if(nrOfUnreadMessages > 0){
                  <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    {{nrOfUnreadMessages}}
                    <span class="visually-hidden">ongelezen berichten</span>
                  </span>
                  }
                </button>
              }
              <button (click)="openChooseBadgeCategoryModal()" type="button"
                class="btn {{badgeCategory() !== undefined ? 'btn-success' : 'btn-outline-dark'}} me-0 position-relative">
                <app-superelf-icon [icon]=facTrophy></app-superelf-icon>
              </button>          
            </div>
          </div>      
        </div>      
        
        @let tmplBadgeCategory = badgeCategory();
        @if(tmplBadgeCategory){
          <div class="text-center mt-3">
            <span class="">
              <app-superelf-badge-icon [badgeCategory]="tmplBadgeCategory"></app-superelf-badge-icon>
              <span class="ms-1">{{nameService.getBadgeCategoryName(tmplBadgeCategory)}}-badge</span>
            </span>          
          </div>
        }
    
        @let tmplActiveGameRound = currentGameRound();
        @if(viewGameRounds() && tmplActiveGameRound && poolUsersWithGameRoundsPoints()){          
          <app-together-ranking 
            [competitorsWithGameRoundsPoints]="poolUsersWithGameRoundsPoints()"
            [viewPeriod]="tmplViewPeriod"
            [previousGameRound]="previousGameRound()"  
            (previousGameRoundPressed)="selectPreviousGameRound(pool.getCompetitionConfig(), tmplCurrentGameRound)"
            [gameRounds]="viewGameRounds()"
            (gameRoundPressed)="openGameRoundInfoModal(pool.getCompetitionConfig(), $event)"
            [nextGameRound]="nextGameRound()"  
            (nextGameRoundPressed)="selectNextGameRound(pool.getCompetitionConfig(), tmplCurrentGameRound)"
            [activeGameRound]="tmplActiveGameRound" 
            [badgeCategory]="tmplBadgeCategory"
            [goatUserId]="goatUserId()"
            [poolId]="+pool.getId()"
            [showTransfers]="showTransfers()"
            [poolUserFromSession]="poolUserFromSession"
            (showCompetitorTransfers)="openPoolUserTransfersModal($event)"            
            (linkToCompetitor)="linkToPoolUser($event)"
            >
          </app-together-ranking>
        }
      }
    } @else {
      <h2 class="text-center">
        <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
      </h2>
    }
  </div>
</div>

@if(!processing() && pool){
  <app-pool-navbar [current]="Competition" [pool]="pool" [poolUser]="poolUserFromSession" [currentGameRound]="initalCurrentGameRound()">
  </app-pool-navbar>
}
